import React from 'react'
import {Icon} from '@chakra-ui/react'

const Close16FilledIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" width="16px" height="16px" flexShrink={0} {...props}>
            <path
                transform="translate(8 8) scale(0.88) translate(-8 -8)"
                d="M11.4697 3.46967C11.7626 3.17678 12.2373 3.17678 12.5302 3.46967C12.8231 3.76257 12.8231 4.23734 12.5302 4.53022L9.06049 7.99994L12.5302 11.4697C12.8231 11.7626 12.8231 12.2373 12.5302 12.5302C12.2373 12.8231 11.7626 12.8231 11.4697 12.5302L7.99994 9.06049L4.53022 12.5302C4.23734 12.8231 3.76257 12.8231 3.46967 12.5302C3.17678 12.2373 3.17678 11.7626 3.46967 11.4697L6.9394 7.99994L3.46967 4.53022C3.17678 4.23732 3.17678 3.76256 3.46967 3.46967C3.76256 3.17678 4.23732 3.17678 4.53022 3.46967L7.99994 6.9394L11.4697 3.46967Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default Close16FilledIcon
